import { isExtensionsInboundCallingEnabled } from 'calling-internal-common/utils/isExtensionsInboundCallingEnabled';
export const getIsExtensionsInboundCallingEnabledInApi = callingProviders => {
  return callingProviders.some(provider => !!provider.supportsInboundCalling);
};
export const getAppIdentifierEligibleForProviderSwitching = appIdentifier => {
  return Boolean(appIdentifier && appIdentifier === 'profile');
};
export const getIsUngatedForBidirectionalProviderSwitching = (gates, appIdentifier, providers) => {
  return Boolean(getAppIdentifierEligibleForProviderSwitching(appIdentifier) && (gates && isExtensionsInboundCallingEnabled(gates) || getIsExtensionsInboundCallingEnabledInApi(providers)));
};